// src/ui/BackToDashboard.jsx
import React, { useMemo } from "react";
import { Link, useLocation } from "react-router-dom";

function resolveTarget(pathname) {
  if (pathname?.startsWith("/architecture")) return "/architecture/dashboard";
  if (pathname?.startsWith("/adventure")) return "/adventure/dashboard";
  return "/ceramics/dashboard";
}

export default function BackToDashboard({ target }) {
  const location = useLocation();

  const computedTarget = useMemo(() => {
    return target || resolveTarget(location.pathname);
  }, [location.pathname, target]);

  return (
    <Link
      to={computedTarget}
      className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-sm border 
                 border-[var(--mudo-border)] bg-[var(--mudo-bg-soft)]/70 
                 text-[var(--mudo-text)] backdrop-blur-md
                 hover:bg-[var(--mudo-bg-soft)] hover:border-[var(--mudo-primary)]
                 transition-colors"
    >
      <span aria-hidden="true" className="text-[var(--mudo-text-muted)]">
        ←
      </span>
      <span>Back to dashboard</span>
    </Link>
  );
}
